// Escolha do tipo → cria o rascunho → vai direto pro editor.
// O rascunho NÃO consome número: a série só anda quando alguém finaliza.
// Por isso o modal não mostra "o próximo será OF-2026-007" — esse número não
// está reservado, e exibi-lo criaria a expectativa de que está.

import { useState } from 'react';
import { App as AntApp, Card, Modal, Space, Tag, Typography } from 'antd';
import { criarExpediente, TipoExpediente } from './api';

const { Text, Paragraph } = Typography;

export default function ModalNovoExpediente({ open, tipos, onClose, onCriado }: {
  open: boolean;
  tipos: TipoExpediente[];
  onClose: () => void;
  onCriado: (id: string) => void;
}) {
  const { message } = AntApp.useApp();
  const [criando, setCriando] = useState<number | null>(null);

  async function escolher(t: TipoExpediente) {
    setCriando(t.id);
    try {
      const r = await criarExpediente(t.id);
      onCriado(r.expediente.id);
    } catch (e: any) {
      message.error('Falha ao criar: ' + (e.response?.data?.error || e.message));
    } finally { setCriando(null); }
  }

  return (
    <Modal
      open={open} onCancel={onClose} footer={null} title="Que documento você quer emitir?"
      width="94vw" style={{ maxWidth: 720, top: 24 }}
      styles={{ body: { maxHeight: 'calc(100vh - 180px)', overflowY: 'auto' } }}
    >
      <Paragraph type="secondary" style={{ fontSize: 12 }}>
        O número sai só quando você finalizar — até lá é rascunho e pode apagar sem
        deixar buraco na numeração.
      </Paragraph>
      <Space direction="vertical" style={{ width: '100%' }} size={10}>
        {tipos.map(t => (
          <Card key={t.id} size="small" hoverable
            loading={criando === t.id}
            onClick={() => criando === null && escolher(t)}
            style={{ cursor: 'pointer' }}
          >
            <Space align="start">
              <Tag color="blue" style={{ fontFamily: 'monospace', fontSize: 13 }}>{t.prefixo}</Tag>
              <div>
                <Text strong>{t.nome}</Text>
                {t.escopo === 'interno' && (
                  <Tag color="geekblue" style={{ marginLeft: 6, fontSize: 10 }}>interno</Tag>
                )}
                {t.descricao && (
                  <div><Text type="secondary" style={{ fontSize: 12 }}>{t.descricao}</Text></div>
                )}
              </div>
            </Space>
          </Card>
        ))}
      </Space>
    </Modal>
  );
}
